import React from 'react';
import PolicyLayout from '../components/PolicyLayout';
import SEOHead from '../components/SEOHead';
import { getSEOConfig } from '../utils/seoConfig';

const CookiePolicyPage: React.FC = () => {
  const seoConfig = getSEOConfig('/cookies');

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />
      <PolicyLayout title="Cookie Policy" lastUpdated="October 2025">
        <p>
          This Cookie Policy explains how GelWel uses cookies and similar tracking technologies on our website
          and mobile application.
        </p>

        <h2>1. What Are Cookies?</h2>
        <p>
          Cookies are small text files stored on your device when you visit a website or use an app. They help
          us recognize you, remember your preferences, and improve your experience.
        </p>

        <h2>2. Types of Cookies We Use</h2>

        <h3>Essential Cookies</h3>
        <p>
          These cookies are necessary for the app to function properly. They enable core features like account
          login, security, and basic navigation.
        </p>

        <h3>Performance and Analytics Cookies</h3>
        <p>
          We use these cookies to understand how users interact with GelWel, which features are most popular,
          and how we can improve the service. This includes tracking page visits, user flows, and error reports.
        </p>

        <h3>Functional Cookies</h3>
        <p>
          These cookies remember your preferences and settings, such as language choice, display settings, and
          notification preferences.
        </p>

        <h3>Advertising and Marketing Cookies</h3>
        <p>
          We may use cookies to deliver personalized content and measure the effectiveness of our marketing
          campaigns. These cookies may track your activity across different websites and apps.
        </p>

        <h2>3. Third-Party Cookies</h2>
        <p>
          We work with trusted third-party service providers who may also set cookies on your device. These
          include analytics providers, advertising networks, and social media platforms. These third parties
          have their own privacy policies governing their use of your information.
        </p>

        <h2>4. Managing Your Cookie Preferences</h2>
        <p>
          You can control and manage cookies in several ways:
        </p>
        <ul>
          <li>Most web browsers allow you to control cookies through their settings. You can set your browser
            to refuse cookies or delete certain cookies.</li>
          <li>Mobile devices offer settings to limit ad tracking and manage app permissions.</li>
          <li>You can opt out of interest-based advertising through industry opt-out tools.</li>
        </ul>
        <p>
          Please note that blocking or deleting cookies may impact your ability to use certain features of GelWel.
        </p>

        <h2>5. Updates to This Policy</h2>
        <p>
          We may update this Cookie Policy from time to time to reflect changes in technology or legal
          requirements. We will notify users of significant changes through the app or via email.
        </p>

        <h2>6. Contact Us</h2>
        <p>
          If you have questions about our use of cookies, please contact us at{' '}
          <a href="mailto:paulfortuneltd@gmail.com">paulfortuneltd@gmail.com</a>.
        </p>
      </PolicyLayout>
    </>
  );
};

export default CookiePolicyPage;
